module.exports = __webpack_public_path__ + "media/images/icons/labor-641614121a61c21018f92fad1f8ce378.svg";